import React from 'react';
import { getEffectivePermissions } from '@shared/helpers/api/mantenedores';

const PermissionBadges = ({ usuario, modulo, todosLosPermisos, onClick }) => {
    // Verificaciones de seguridad
    if (!usuario || !modulo || !todosLosPermisos) {
        console.warn('⚠️ PermissionBadges: Datos faltantes', { usuario: !!usuario, modulo: !!modulo, todosLosPermisos: !!todosLosPermisos });
        return (
            <div style={{ fontSize: '12px', color: '#999', fontStyle: 'italic' }}>
                Sin permisos
            </div>
        );
    }

    if (!usuario.modulos || !usuario.modulos[modulo]) {
        console.warn(`⚠️ PermissionBadges: Módulo ${modulo} no encontrado para usuario ${usuario.nombre}`, {
            usuarioModulos: Object.keys(usuario.modulos || {}),
            moduloBuscado: modulo
        });
        return (
            <div style={{ fontSize: '12px', color: '#999', fontStyle: 'italic' }}>
                Sin permisos
            </div>
        );
    }

    const effectivePermissions = getEffectivePermissions(usuario, modulo, todosLosPermisos);
    const hasAdministrar = usuario.modulos[modulo]?.permisos?.some(p => p.permiso === 'administrar');

    // console.log(`🔍 PermissionBadges ${usuario.nombre} - ${modulo}:`, {
    //     permisosDirectos: usuario.modulos[modulo]?.permisos?.length || 0,
    //     permisosEfectivos: effectivePermissions?.length || 0,
    //     hasAdministrar,
    //     permisosDirectosDetalle: usuario.modulos[modulo]?.permisos?.map(p => p.permiso)
    // });

    // Estilos para los badges
    const badgeStyles = {
        vista: { backgroundColor: '#e3f2fd', color: '#1565c0', icon: '👁️' },
        crear: { backgroundColor: '#e8f5e8', color: '#2e7d32', icon: '➕' },
        editar: { backgroundColor: '#fff3e0', color: '#f57c00', icon: '✏️' },
        eliminar: { backgroundColor: '#ffebee', color: '#c62828', icon: '🗑️' },
        exportar: { backgroundColor: '#f3e5f5', color: '#7b1fa2', icon: '📤' },
        aprobar: { backgroundColor: '#e0f7fa', color: '#00838f', icon: '✅' },
        administrar: { backgroundColor: '#e8eaf6', color: '#3f51b5', icon: '👑' }
    };

    const baseBadgeStyle = {
        display: 'inline-flex',
        alignItems: 'center',
        padding: '2px 6px', // Reducir padding horizontal
        margin: '1px', // Reducir margin
        borderRadius: '10px', // Reducir border radius
        fontSize: '10px', // Reducir tamaño de fuente
        fontWeight: '500',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        border: '1px solid transparent',
        whiteSpace: 'nowrap' // Evitar que se rompa el texto
    };

    // Si tiene administrar, mostrar solo ese badge con indicación especial
    if (hasAdministrar) {
        const adminStyle = {
            ...baseBadgeStyle,
            ...badgeStyles.administrar,
            border: '2px solid #3f51b5',
            boxShadow: '0 2px 4px rgba(63, 81, 181, 0.2)'
        };

        return (
            <div 
                style={{ 
                    display: 'flex', 
                    flexWrap: 'wrap', 
                    alignItems: 'center',
                    minHeight: '24px'
                }}
            >
                <div
                    style={adminStyle}
                    onClick={() => onClick && onClick(usuario, modulo)}
                    title="Administrador - Tiene todos los permisos"
                >
                    👑 Administrador
                </div>
                <span style={{ 
                    fontSize: '10px', 
                    color: '#666', 
                    marginLeft: '4px',
                    fontStyle: 'italic'
                }}>
                    (todos los permisos)
                </span>
            </div>
        );
    }

    // Mostrar badges individuales
    if (effectivePermissions.length === 0) {
        return (
            <div 
                style={{ 
                    display: 'flex', 
                    alignItems: 'center',
                    minHeight: '24px',
                    color: '#999',
                    fontSize: '12px',
                    fontStyle: 'italic',
                    cursor: 'pointer'
                }}
                onClick={() => onClick && onClick(usuario, modulo)}
                title="Click para editar permisos"
            >
                Sin permisos
            </div>
        );
    }

    return (
        <div 
            style={{ 
                display: 'flex', 
                flexWrap: 'wrap', 
                alignItems: 'center',
                minHeight: '24px',
                cursor: onClick ? 'pointer' : 'default',
                maxWidth: '100%',
                gap: '1px' // Usar gap en lugar de margin en los items
            }}
            onClick={() => onClick && onClick(usuario, modulo)}
            title={onClick ? "Click para editar permisos" : ""}
        >
            {effectivePermissions.map(permiso => {
                const style = {
                    ...baseBadgeStyle,
                    ...badgeStyles[permiso.permiso],
                    margin: '0' // Remover margin individual ya que usamos gap
                };

                return (
                    <div
                        key={permiso.id}
                        style={style}
                    >
                        {badgeStyles[permiso.permiso]?.icon} {permiso.permiso}
                    </div>
                );
            })}
        </div>
    );
};

export default PermissionBadges;
